import { render, staticRenderFns } from "./virtual_dept_structure.vue?vue&type=template&id=17b76770"
import script from "./virtual_dept_structure.vue?vue&type=script&lang=js"
export * from "./virtual_dept_structure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports